<template>
  <span v-if="isPropertiesExist" class="battery-state">
    <template v-if="object.deviceBatteryType === false && !isUnknown">
      <v-icon
        title="Battery level"
        :size="size"
        color="red"
        v-if="object.deviceIsBatteryLow === true"
      >
        mdi-battery-alert
      </v-icon>
      <v-icon title="Battery level" :size="size" v-else> mdi-battery</v-icon>
      <span v-if="object.deviceIsBatteryLow === true" class="red--text">
        {{ object.deviceBatteryLevel }}%
      </span>
      <span v-else> {{ object.deviceBatteryLevel }}% </span>
    </template>
    <v-icon :size="size" v-else-if="object.deviceBatteryType === true">
      mdi-power-plug
    </v-icon>
    <v-icon title="Battery level" :size="size" v-else>
      mdi-battery-unknown</v-icon
    >
  </span>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  name: 'BatteryState',
  props: {
    object: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: '16px'
    }
  },
  setup(props) {
    const isUnknown = computed(
      () =>
        props.object.deviceBatteryType === null ||
        props.object.deviceBatteryLevel === null
    );

    const isPropertiesExist = computed(
      () =>
        props.object.deviceBatteryType !== undefined ||
        props.object.deviceBatteryLevel !== undefined ||
        props.object.deviceIsBatteryLow !== undefined
    );

    return {
      isUnknown,
      isPropertiesExist
    };
  }
};
</script>

<style lang="scss">
.battery-state {
  display: inline-flex;
  align-items: center;
}
</style>
